import { render, staticRenderFns } from "./stripe-elements.vue?vue&type=template&id=1949155b&scoped=true&"
import script from "./stripe-elements.vue?vue&type=script&lang=js&"
export * from "./stripe-elements.vue?vue&type=script&lang=js&"
import style0 from "./stripe-elements.vue?vue&type=style&index=0&id=1949155b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1949155b",
  null
  
)

export default component.exports